import { VStack } from 'lib/ui/Stack';
import styled from 'styled-components';

export const PageLayout = styled(VStack)`
  gap: 32px;
  width: 100%;
  position: relative;
`;
